import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLocationDot} from "@fortawesome/sharp-solid-svg-icons/faLocationDot";

// NOTE If you change the text size, be sure to change the styles of
//  CampusNavItem's root and the `w-24`s in this so it reserves the proper space for the text
export const locationLabelStyles = "flex items-center gap-2";

/**
 * Campus name and location pin
 */
const CampusLabel: React.FC<{campusName: string}> = ({campusName}) => (
	<>
		<FontAwesomeIcon icon={faLocationDot} />
		<span className="max-w-24 overflow-hidden text-ellipsis whitespace-nowrap">
			{campusName}
		</span>
	</>
);

export default CampusLabel;
